import { MutationHookOptions, gql } from "@apollo/client"
import { useMutation } from "@oysterhr/core"

const UpdateOffboardingFormMutation = gql`
  mutation UpdateOffboardingForm(
    $terminationId: ID!
    $proposedDate: ISO8601Date
    $reason: String
    $communicatedWithEmployee: Boolean
    $intendedDaysOff: Float
    $notes: String
    $ptoAccurate: Boolean
    $ptoInaccurateNote: String
    $state: TerminationState
    $primaryCategoryId: ID
    $secondaryCategoryId: ID
    $notifyCustomerAdmin: Boolean
    $onLeave: Boolean
    $paidInFullCheckDate: ISO8601Date
    $earlyOffboardingRequested: Boolean
    $earlyOffboardingReason: String
    $teamMemberOwedCommission: Boolean
    $commissionDetails: String
    $lastDayOn: ISO8601Date
    $lastWorkingDay: ISO8601Date
    $mutualTermination: Boolean
    $serviceAgreementSignature: ISO8601Date
    $additionalConsiderationAmountToBeConfirmed: Boolean
    $additionalConsiderationAmount: Float
    $additionalConsiderationCurrencyCode: String
    $additionalNotesForDepositTeam: Boolean
    $staffDepositNote: String
    $noticeAttributes: EmploymentNoticeInput
    $severanceAttributes: EmploymentSeveranceInput
  ) {
    updateTermination(
      input: {
        terminationId: $terminationId
        proposedDate: $proposedDate
        reason: $reason
        communicatedWithEmployee: $communicatedWithEmployee
        intendedDaysOff: $intendedDaysOff
        ptoAccurate: $ptoAccurate
        ptoInaccurateNote: $ptoInaccurateNote
        notes: $notes
        state: $state
        primaryCategoryId: $primaryCategoryId
        secondaryCategoryId: $secondaryCategoryId
        notifyCustomerAdmin: $notifyCustomerAdmin
        onLeave: $onLeave
        paidInFullCheckDate: $paidInFullCheckDate
        earlyOffboardingRequested: $earlyOffboardingRequested
        earlyOffboardingReason: $earlyOffboardingReason
        teamMemberOwedCommission: $teamMemberOwedCommission
        commissionDetails: $commissionDetails
        lastDayOn: $lastDayOn
        lastWorkingDay: $lastWorkingDay
        mutualTermination: $mutualTermination
        serviceAgreementSignature: $serviceAgreementSignature
        additionalConsiderationAmountToBeConfirmed: $additionalConsiderationAmountToBeConfirmed
        additionalConsiderationAmount: $additionalConsiderationAmount
        additionalConsiderationCurrencyCode: $additionalConsiderationCurrencyCode
        additionalNotesForDepositTeam: $additionalNotesForDepositTeam
        staffDepositNote: $staffDepositNote
        noticeAttributes: $noticeAttributes
        severanceAttributes: $severanceAttributes
      }
    ) {
      errors
    }
  }
`

export const useUpdateOffboardingForm = (options?: MutationHookOptions) => {
  return useMutation(UpdateOffboardingFormMutation, options)
}
